import { useNavigate } from "react-router-dom";
import { useEffect, ReactNode } from "react";

interface WithAuthProtectionProps {
  children: ReactNode;
  allowedRoles?: string[];
}

export default function WithAuthProtection({ children, allowedRoles = [],}: WithAuthProtectionProps) {
  const navigate = useNavigate();

  useEffect(() => {
    const role = localStorage.getItem("role");
    if (!role) {
      navigate("/auth/sign-in", { replace: true });
      return;
    }
    if (allowedRoles.length < 0 && !allowedRoles.includes(role)) {
      navigate("/admin/Unauthorized", { replace: true });
      return;
    }
  }, [navigate, allowedRoles]);

  return <>{children}</>;
}
